module.exports = __webpack_public_path__ + "img/home_icon_jiegou_sel.5927773f.png";